export default {"src":"__ASTRO_ASSET_IMAGE__D3j_0x4b__","width":88,"height":88,"format":"svg"}